export default __webpack_public_path__ + "img/separator.cf06448670b473d56240ccd86f8a76bf.svg";